import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import ModalPembayaranTagihan from './modals/modalPembayaranTagihan'
import ModalDetailIuranBulanan from './modals/showModalDetailIuranBulanan'
import { months } from 'dataSource/lookup'

class ProsesIuranDapen extends Component {
  constructor(props) {
    super(props)
    this.participantId = this.props.store.getState().sessionUser
      ? this.props.store.getState().sessionUser.participantId
      : 0
    this.dataGridRef = React.createRef()
    this.showModalPembayaranTagihanRef = React.createRef()
    this.modalDetailProcesIuranDapenRef = React.createRef()

    this.columns = [
      {
        type: 'buttons',
        buttons: [
          'edit',
          {
            text: 'Detail Iuran',
            hint: 'edit',
            onClick: (e) => {
              this.showModalDetilProcesIuranDapen(e.row.data)
            },
          },
          {
            text: 'Pembayaran Tagihan',
            hint: 'edit',
            onClick: async (e) => {
              this.showModalPembayaranTagihan(e.row.data)
            },
          },
        ],
      },
      {
        dataField: 'rowNumber',
        caption: 'No.',
        cellRender: (data) => {
          return data.rowIndex + 1
        },
      },
      {
        dataField: 'invoiceNo',
        caption: 'No. Invoice',
      },
      {
        dataField: 'tahun',
        caption: 'Iuran Tahun',
        dataType: 'number',
      },
      {
        dataField: 'bulan',
        caption: 'Iuran Bulan',
        lookup: {
          dataSource: months,
          valueExpr: 'id',
          displayExpr: 'value',
        },
      },
      {
        dataField: 'invoiceDate',
        caption: 'Tanggal Invoice',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      {
        dataField: 'jumlahAkunPeserta',
        caption: 'Jumlah Akun Peserta',
        dataType: 'number',
      },
      {
        dataField: 'productName',
        caption: 'Produk',
      },
      {
        dataField: 'iuranPk',
        caption: 'Iuran PK',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuranLain',
        caption: 'Iuran Lain',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'biayaIuran',
        caption: 'Biaya Iuran',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'invoiceNominal',
        caption: 'Total Tagihan',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'outstandingAmount',
        caption: 'Outstanding Tagihan',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'status',
        caption: 'Status',
      },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  refreshDataGrid = () => {
    this.dataGridRef.current.forceRefresh()
  }

  forceRefresh = () => {
    this.dataGridRef.current.forceRefresh(true)
  }

  showModalDetilProcesIuranDapen = (data) => {
    this.modalDetailProcesIuranDapenRef.current.show()
    this.modalDetailProcesIuranDapenRef.current.retrieveData(data)
  }

  showModalPembayaranTagihan = (data) => {
    this.showModalPembayaranTagihanRef.current.show()
    this.showModalPembayaranTagihanRef.current.retrieveData(data)
  }

  render() {
    return (
      <div className="container-fluid">
        <h2 className="main-title">Data Tagihan Bulanan</h2>

        <DevExpressDataGrid
          ref={this.dataGridRef}
          loadAPI={`wp/tagihan-bulanans?participantId.equals=${this.participantId}&status.in=Open&status.in=Partial%20Payment`}
          insertAPI="-"
          updateAPI="-"
          deleteAPI="-"
          backendserver={process.env.REACT_APP_BACKEND_CORE}
          remoteOperations={true}
          useArraySource={false}
          ArraySourceData={''}
          allowAdding={false}
          allowDeleting={false}
          allowUpdating={false}
          exportExcel={false}
          exportFileName={'Proses Iuran Dapen'}
          allowExportSelectedData={true}
          selection={'multiple'}
          showBorders={true}
          paging={true}
          defaultPageSize={10}
          height={'80vh'}
          popupTitle={'Proses Iuran Dapen'}
          popupWidth={700}
          popupHeight={500}
          popupFormLabelLocation="left"
          popupFormMinColWidth={300}
          popupFormColCount={3}
          ColumnChooser={true}
          ColumnFixing={true}
          FilterRow={true}
          ColumnConfiguration={this.columns}
          SummaryConfiguration={this.summary}
          store={this.props.store}
        />
        <ModalPembayaranTagihan
          ref={this.showModalPembayaranTagihanRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
        <ModalDetailIuranBulanan
          ref={this.modalDetailProcesIuranDapenRef}
          store={this.props.store}
          forceRefresh={this.forceRefresh}
        />
      </div>
    )
  }
}

export default ProsesIuranDapen
